import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { SERVICES, LOCATION_PAGES } from '../seo/seoLandingConfig';

/**
 * Dezenter Linkblock im Footer: Standorte und Leistungen.
 * Bewusst kurz — früher standen hier 55 Stadtlinks, die Google als
 * Linksammlung wertet.
 */
const SEOFooterLinks = () => {
  const [open, setOpen] = useState(false);

  return (
    <div className="border-t border-white/5 mt-8 pt-6" data-testid="seo-footer-links">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="flex items-center gap-2 text-[11px] font-semibold uppercase tracking-wider text-[#605e5e] hover:text-[#a1a1aa] transition-colors"
        data-testid="seo-footer-toggle"
      >
        Standorte &amp; Leistungen
        {open ? <ChevronUp className="w-3 h-3" /> : <ChevronDown className="w-3 h-3" />}
      </button>

      {/* Kompakte Vorschau IMMER sichtbar: Standorte + Leistungen */}
      {!open && (
        <div className="mt-3 flex flex-wrap gap-x-3 gap-y-1.5">
          {LOCATION_PAGES.map((l) => (
            <Link
              key={l.slug}
              to={`/standort/${l.slug}`}
              className="text-[11px] text-[#605e5e] hover:text-[#0094ff] transition-colors"
              data-testid={`seo-quick-link-${l.slug}`}
            >
              Aufbereiter {l.city}
            </Link>
          ))}
          {SERVICES.map((s) => (
            <Link
              key={s.slug}
              to={`/${s.slug}`}
              className="text-[11px] text-[#605e5e] hover:text-[#0094ff] transition-colors"
            >
              {s.name}
            </Link>
          ))}
        </div>
      )}

      {open && (
        <div className="mt-4 space-y-5 text-xs">
          <div>
            <p className="text-[#a1a1aa] font-medium mb-1.5">Standorte</p>
            <div className="flex flex-wrap gap-x-3 gap-y-1">
              {LOCATION_PAGES.map((l) => (
                <Link key={l.slug} to={`/standort/${l.slug}`} className="text-[#605e5e] hover:text-[#0094ff] transition-colors">
                  {l.name} · {l.city}
                </Link>
              ))}
              <Link to="/einzugsgebiet" className="text-[#605e5e] hover:text-[#0094ff] transition-colors">Einzugsgebiet</Link>
            </div>
          </div>
          <div>
            <p className="text-[#a1a1aa] font-medium mb-1.5">Leistungen</p>
            <div className="flex flex-wrap gap-x-3 gap-y-1">
              {SERVICES.map((s) => (
                <Link key={s.slug} to={`/${s.slug}`} className="text-[#605e5e] hover:text-[#0094ff] transition-colors">
                  {s.name}
                </Link>
              ))}
              <Link to="/waschbox-finder" className="text-[#605e5e] hover:text-[#0094ff] transition-colors">Waschbox-Finder</Link>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SEOFooterLinks;
